import { CategoryDetails_category } from "@saleor/categories/types/CategoryDetails"
import { CollectionDetails_collection } from "@saleor/collections/types/CollectionDetails";
import { ProductDetails_product } from "@saleor/products/types/ProductDetails";
    import { ProductDetails_product_recommendProducts } from "@saleor/products/types/ProductDetails";
import { RecommendProductReorderVariables } from "@saleor/products/types/RecommendProductReorder"
import { ReorderEvent } from "@saleor/types";
import {
    RecommendationTargetTypeEnum,
    RecommendationTypeEnum } from "@saleor/types/globalTypes";
    
export function createRecommendProductReorderHandler(
    target: ProductDetails_product | CategoryDetails_category | CollectionDetails_collection,
    targetType: RecommendationTargetTypeEnum,
    recommendType: RecommendationTypeEnum,
    products: ProductDetails_product_recommendProducts[],
    reorderRecommendProducts: (variables: RecommendProductReorderVariables) => void
  ) {
    return ({ newIndex, oldIndex }: ReorderEvent) => {
      reorderRecommendProducts({
        move: {
          productId: products[oldIndex].id,
          sortOrder: newIndex - oldIndex
        },
        targetId: target.id,
        targetType,
        recommendType,
      });
    };
  }
